/* istanbul ignore file */
// this is a mock file for testing

import type {
  CompanyNameSlug as CompanyNameSlugFromGraph,
  PostCompanyProfileReviewFlagPayload as ReviewFlagPayloadFromGraph,
  PostCompanyProfileReviewUpvotesPayload as ReviewUpvotesPayloadFromGraph,
} from '@seek/ca-graphql-schema/types';
import {
  type Jobs,
  type Reviews,
  type ReviewUpvotes as ReviewUpvotesFromGraph,
  type Zone,
  ORPHAN_REVIEW_COMPANY_ID,
} from '@seek/libs-shared';

import type { CompaniesListModel } from '../../../companyProfiles/models/companiesListModel';
import type { AppConfig } from '../../config';

import type { CompanyProfileService } from './companyProfileService';
import { getMockCompanyNameSlug } from './mock/getMockCompanyNameSlug';
import { getMockReviews } from './mock/getMockReviews';
import type { SearchCompanyProfileResult, SearchResults } from './types';

const jobs = [
  {
    id: '72846618',
    title: 'Finance Manager',
    url: '/job/72846618',
    advertiser: 'JLL',
    classification: 'Accounting',
    subClassification: 'Financial Managers & Controllers',
    description:
      'Be part of one of our new accounts with potential for future growth! You get to work with key stakeholders to kickstart the account.',
    createdAt: '2024-01-08T22:27:05Z',
    listingDateDisplay: '7d ago',
    bulletPoints: [],
    salaryDisplayFlag: false,
    location: 'Melbourne - CBD & Inner Suburbs',
  },
  {
    id: '72846604',
    title: 'Finance Manager',
    url: '/job/72846604',
    advertiser: 'JLL',
    classification: 'Accounting',
    subClassification: 'Financial Managers & Controllers',
    description:
      'Be part of one of our new accounts with potential for future growth! You get to work with key stakeholders to kickstart the account.',
    createdAt: '2024-01-08T22:26:30Z',
    listingDateDisplay: '7d ago',
    bulletPoints: [],
    salaryDisplayFlag: false,
    location: 'Sydney - CBD, Inner West & Eastern Suburbs',
  },
  {
    id: '73069630',
    title: 'Receptionist',
    url: '/job/73069630',
    advertiser: 'JLL',
    classification: 'Administration & Office Support',
    subClassification: 'Receptionists',
    description:
      'Ensure a seamless and professional experience for all client staff and their visitors. Global investment management client with a CBD location!',
    createdAt: '2024-01-17T01:12:00Z',
    listingDateDisplay: '7d ago',
    bulletPoints: [
      'Great culture and collaborative environment, working with a fun team!',
      'Future growth opportunities and network opportunities to develop your career',
      'Employee development and well-being are prioritised',
    ],
    salaryDisplayFlag: false,
    location: 'Melbourne - CBD & Inner Suburbs',
  },
  {
    id: '73062756',
    title: 'Facilities Coordinator',
    url: '/job/73062756',
    advertiser: 'JLL',
    classification: 'Real Estate & Property',
    subClassification: 'Body Corporate & Facilities Management',
    description:
      'Take the next step in your Facilities career, based at a client site in Melbourne!',
    createdAt: '2024-01-16T19:49:15Z',
    listingDateDisplay: '7d ago',
    bulletPoints: [
      'Your opportunity to innovate and put your expertise into action',
      'Full-time position with long term career opportunities',
      'Become a member of a diverse & supportive team dedicated to the work we do',
    ],
    salaryDisplayFlag: false,
    location: 'Melbourne - CBD & Inner Suburbs',
  },
  {
    id: '73065766',
    title: 'Property Manager - Compliance',
    url: '/job/73065766',
    advertiser: 'JLL',
    classification: 'Real Estate & Property',
    subClassification: 'Commercial Sales, Leasing & Property Mgmt',
    description:
      'Newly created compliance role due to growth! Do you hold experience as a commercial PM, looking to develop your career in premium office assets?',
    createdAt: '2024-01-16T23:10:25Z',
    listingDateDisplay: '7d ago',
    bulletPoints: [],
    salaryDisplayFlag: false,
    location: 'Sydney - CBD, Inner West & Eastern Suburbs',
  },
  {
    id: '72980277',
    title: 'Senior Finance Manager',
    url: '/job/72980277',
    advertiser: 'JLL',
    classification: 'Accounting',
    subClassification: 'Financial Managers & Controllers',
    description:
      'Responsible for two premium commercial sites with view for growth. Based in North Sydney accessible to a new metro station.',
    createdAt: '2024-01-12T11:08:24Z',
    listingDateDisplay: '7d ago',
    bulletPoints: [],
    salaryDisplayFlag: false,
    location: 'Sydney - North Shore & Northern Beaches',
  },
  {
    id: '73066026',
    title: 'Workplace Manager',
    url: '/job/73066026',
    advertiser: 'JLL',
    classification: 'Real Estate & Property',
    subClassification: 'Body Corporate & Facilities Management',
    description:
      'Exciting mixed-use portfolio. Join a dynamic, talented & supportive team, learn from the best! Are you ready to elevate your career in workplace mgt?',
    createdAt: '2024-01-16T23:23:25Z',
    listingDateDisplay: '23h ago',
    bulletPoints: [],
    salaryDisplayFlag: false,
    location: 'Brisbane - CBD & Inner Suburbs',
  },
  {
    id: '73034969',
    title: 'Receptionist',
    url: '/job/73034969',
    advertiser: 'JLL',
    classification: 'Administration & Office Support',
    subClassification: 'Receptionists',
    description:
      'Provide our globally recognised client with superior and efficient front of house service, providing a warm and energetic workplace experience!',
    createdAt: '2024-01-15T23:47:02Z',
    listingDateDisplay: '29d ago',
    bulletPoints: [
      'Great culture and collaborative environment, working with a fun team!',
      'Future growth opportunities and network opportunities to develop your career',
      "JLL is Australia's largest Commercial Real Estate Company",
    ],
    salaryDisplayFlag: false,
    location: 'Sydney - CBD, Inner West & Eastern Suburbs',
  },
  {
    id: '73014383',
    title: 'Regional Facilities Manager',
    url: '/job/73014383',
    advertiser: 'JLL',
    classification: 'Real Estate & Property',
    subClassification: 'Body Corporate & Facilities Management',
    description:
      'Manage the day-to-day Facilities Activities across the client portfolio in Australia and New Zealand.',
    createdAt: '2024-01-15T04:19:26Z',
    listingDateDisplay: '29d ago',
    bulletPoints: [
      'Great culture and collaborative environment, working with a fun team!',
      'Future growth opportunities and network opportunities to develop your career',
      'Develop and implement a building strategy for tomorrow and the future!',
    ],
    salaryDisplayFlag: false,
    location: 'Sydney - CBD, Inner West & Eastern Suburbs',
  },
  {
    id: '72941839',
    title: 'Receptionist',
    url: '/job/72941839',
    advertiser: 'JLL',
    classification: 'Administration & Office Support',
    subClassification: 'Receptionists',
    description:
      "We're searching for a skilled, energetic and proactive receptionist to join our team, working with a tech giant, Google! Melb CBD location.",
    createdAt: '2024-01-11T08:31:22Z',
    listingDateDisplay: '2h ago',
    bulletPoints: [
      'Great culture and collaborative environment, working with a fun team!',
      'Part of an active, visible workplace team that is engaging, proactive and agile',
      'Endless snacks throughout the day! Free brekky AND lunch!',
    ],
    salaryDisplayFlag: false,
    location: 'Melbourne - CBD & Inner Suburbs',
  },
  {
    id: '72942839',
    title: 'Receptionist',
    url: '/job/72941839',
    advertiser: 'JLL',
    classification: 'Administration & Office Support',
    subClassification: 'Receptionists',
    description:
      "We're searching for a skilled, energetic and proactive receptionist to join our team, working with a tech giant, Google! Melb CBD location.",
    createdAt: '2024-01-11T08:31:22Z',
    listingDateDisplay: '15d ago',
    bulletPoints: [
      'Great culture and collaborative environment, working with a fun team!',
      'Part of an active, visible workplace team that is engaging, proactive and agile',
      'Endless snacks throughout the day! Free brekky AND lunch!',
    ],
    salaryDisplayFlag: false,
    location: 'Melbourne - CBD & Inner Suburbs',
  },
  {
    id: '72941840',
    title: 'Receptionist',
    url: '/job/72941839',
    advertiser: 'JLL',
    classification: 'Administration & Office Support',
    subClassification: 'Receptionists',
    description:
      "We're searching for a skilled, energetic and proactive receptionist to join our team, working with a tech giant, Google! Melb CBD location.",
    createdAt: '2024-01-11T08:31:22Z',
    listingDateDisplay: '11d ago',
    bulletPoints: [
      'Great culture and collaborative environment, working with a fun team!',
      'Part of an active, visible workplace team that is engaging, proactive and agile',
      'Endless snacks throughout the day! Free brekky AND lunch!',
    ],
    salaryDisplayFlag: false,
    location: 'Melbourne - CBD & Inner Suburbs',
  },
  {
    id: '72941841',
    title: 'Receptionist',
    url: '/job/72941839',
    advertiser: 'JLL',
    classification: 'Administration & Office Support',
    subClassification: 'Receptionists',
    description:
      "We're searching for a skilled, energetic and proactive receptionist to join our team, working with a tech giant, Google! Melb CBD location.",
    createdAt: '2024-01-11T08:31:22Z',
    listingDateDisplay: '4d ago',
    bulletPoints: [
      'Great culture and collaborative environment, working with a fun team!',
      'Part of an active, visible workplace team that is engaging, proactive and agile',
      'Endless snacks throughout the day! Free brekky AND lunch!',
    ],
    salaryDisplayFlag: false,
    location: 'Melbourne - CBD & Inner Suburbs',
  },
  {
    id: '72941842',
    title: 'Receptionist',
    url: '/job/72941839',
    advertiser: 'JLL',
    classification: 'Administration & Office Support',
    subClassification: 'Receptionists',
    description:
      "We're searching for a skilled, energetic and proactive receptionist to join our team, working with a tech giant, Google! Melb CBD location.",
    createdAt: '2024-01-11T08:31:22Z',
    listingDateDisplay: '2d ago',
    bulletPoints: [
      'Great culture and collaborative environment, working with a fun team!',
      'Part of an active, visible workplace team that is engaging, proactive and agile',
      'Endless snacks throughout the day! Free brekky AND lunch!',
    ],
    salaryDisplayFlag: false,
    location: 'Melbourne - CBD & Inner Suburbs',
  },
];

export const createCompanyProfileServiceMock = (_props: {
  config: AppConfig;
}): CompanyProfileService => {
  const getCompanyProfileForeignId = async (
    companyId: string,
  ): Promise<string> => Promise.resolve(`99${companyId}`);

  const getJobs = async (companyId: string, page?: number): Promise<Jobs> =>
    Promise.resolve({
      jobs: jobs.slice((page || 1) * 10 - 10, (page || 1) * 10),
      totalJobs: jobs.length,
    });

  const getReviews = async ({
    companyId,
    page,
  }: {
    companyId: string;
    page?: number;
  }): Promise<Reviews> => Promise.resolve(getMockReviews(companyId, page));

  const getCompanyNameSlug = async (
    companySlug: string,
    isLegacyUrl: boolean,
  ): Promise<CompanyNameSlugFromGraph> =>
    Promise.resolve(getMockCompanyNameSlug(companySlug, isLegacyUrl));

  const getUpvoteIds = async (): Promise<ReviewUpvotesFromGraph> =>
    Promise.resolve({
      upvotes: ['205163'],
    });

  const postUpvoteReview = async (): Promise<
    ReviewUpvotesPayloadFromGraph | undefined
  > =>
    Promise.resolve({
      success: true,
    });

  const postFlagReview = async (): Promise<
    ReviewFlagPayloadFromGraph | undefined
  > =>
    Promise.resolve({
      success: true,
    });

  const getGroupedCompanies = async (): Promise<CompaniesListModel> =>
    Promise.resolve([
      {
        name: 'Optus',
        slug: 'optus-432323',
        id: '432323',
      },
      {
        name: 'ANZ',
        slug: 'anz-432303',
        id: '432303',
      },
      {
        name: 'Seek',
        slug: 'seek-432600',
        id: '432600',
      },
      {
        name: 'MYOB',
        slug: 'myob-432833',
        id: '432833',
      },
      {
        name: 'Microsoft',
        slug: 'microsoft-432456',
        id: '432456',
      },
      {
        name: 'UBS',
        slug: 'ubs-432955',
        id: '432955',
      },
      {
        name: 'TAFE NSW',
        slug: 'tafe-nsw-432512',
        id: '432512',
      },
      {
        name: 'Coles Group',
        slug: 'coles-group-433124',
        id: '433124',
      },
      {
        name: 'Here is a company with a pretty long name',
        slug: 'bendigo-n-adelaide-bank-432953',
        id: '432953',
      },
      {
        name: 'HammondCare',
        slug: 'hammondcare-434584',
        id: '434584',
      },
      {
        name: 'Findex',
        slug: 'findex-813706',
        id: '813706',
      },
      {
        name: 'Domain Group',
        slug: 'domain-group-753299',
        id: '753299',
      },
      {
        name: 'Dell',
        slug: 'dell-432499',
        id: '432499',
      },
      {
        name: 'Aruma',
        slug: 'aruma-432975',
        id: '432975',
      },
      {
        name: 'Scentre Group',
        slug: 'scentre-group-752989',
        id: '752989',
      },
    ]);

  const getCompanyProfilesByName = async (
    name: string,
    _includeBranding = false,
  ): Promise<SearchCompanyProfileResult> => {
    const profiles = [
      {
        companyId: '432323',
        organisationId: '1111',
        data: {
          name: 'Optus',
          published: true,
        },
        zone: 'anz-1',
      },
      {
        companyId: '432303',
        organisationId: '2222',
        data: {
          name: 'ANZ',
          published: true,
        },
        zone: 'anz-1',
      },
      {
        companyId: '432600',
        organisationId: '3333',
        data: {
          name: 'Seek',
          published: true,
        },
        zone: 'anz-1',
      },
      {
        companyId: '432600',
        organisationId: '3987',
        zone: 'anz-1',
        data: {
          branding: {
            logoImageUrl:
              'https://image-service-cdn.staging.seek.com.au/test-c53f230660ad2d5819cc7fa6d50a6962cbc77586/f3c5292cec0e05e4272d9bf9146f390d366481d0',
          },
          name: 'Seek with logo',
          overview: {
            description: ['Lorem ipsum - test'],
            industry: 'Information & Communication Technology',
            size: '11-50',
            primaryLocation: 'Level 6 541 St Kilda Road, Melbourne, Victoria',
            specialities: [
              'technology',
              'marketing',
              'eCommerce',
              'business',
              'sdasdsada',
            ],
          },
          published: true,
        },
      },
      {
        companyId: ORPHAN_REVIEW_COMPANY_ID,
        organisationId: '358922',
        zone: 'anz-1',
        data: {
          name: 'Seeka',
          overview: {},
          published: false,
        },
      },
      {
        companyId: '438952',
        organisationId: '4202',
        zone: 'anz-1',
        data: {
          branding: {
            logoImageUrl:
              'https://d2ojpxxtu63wzl.cloudfront.net/static/06d998de2cf4dcc2b11aab2654b805ad_384b032e1f2cb592a65ff1ab38cba8ad747b1b12b1ec6becb3cfa822c8ec23d7',
          },
          name: 'Seek Support',
          overview: {
            description: [
              '•Labour Hire •HR & HSEQ Specialists •Audit Preparation •Site and Office Inspections •Recruitment •Marketing Strategies •Admin Support •Certification Support •',
            ],
            website: {
              url: 'www.seeksupport.com.au',
            },
            primaryLocation: 'SE 3\nANTIGUA ST 2\n6169\nSAFETY BAY\nAustralia',
          },
          published: true,
        },
      },
    ];

    const sortedProfiles = profiles.sort((a, b) => {
      const aMatches = a.data.name.toLowerCase() === name.toLowerCase();
      const bMatches = b.data.name.toLowerCase() === name.toLowerCase();

      if (aMatches && !bMatches) return -1;
      if (!aMatches && bMatches) return 1;
      return 0;
    });

    return Promise.resolve(sortedProfiles as SearchCompanyProfileResult);
  };

  const searchCompanyProfile = async (options: {
    name: string;
    zone: Zone;
  }): Promise<SearchResults> =>
    Promise.resolve({
      data: [
        {
          companyId: '432323',
          organisationId: '1111',
          slug: options.name,
          zone: options.zone,
          name: options.name,
          logoUrl:
            'https://image-service-cdn.staging.seek.com.au/test-c53f230660ad2d5819cc7fa6d50a6962cbc77586/f3c5292cec0e05e4272d9bf9146f390d366481d0',
          overallRating: {
            rating: 3.3,
            count: 111,
          },
        },
        {
          companyId: '432600',
          organisationId: '3333',
          zone: options.zone,
          slug: 'seek',
          name: 'Seek',
          overallRating: {
            rating: 4.5,
            count: 321,
          },
          logoUrl:
            'https://image-service-cdn.staging.seek.com.au/test-c53f230660ad2d5819cc7fa6d50a6962cbc77586/f3c5292cec0e05e4272d9bf9146f390d366481d0',
        },
      ],
      paging: { page: 1, perPage: 10, total: 333, totalPages: 34 },
    });

  return {
    searchCompanyProfile,
    getCompanyNameSlug,
    getCompanyProfileForeignId,
    getJobs,
    getReviews,
    getUpvoteIds,
    postUpvoteReview,
    postFlagReview,
    getGroupedCompanies,
    getCompanyProfilesByName,
  };
};
